import React, { useEffect, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
// import format from 'date-fns/format';
import Box from '@material-ui/core/Box';
import { makeStyles } from '@material-ui/core/styles';
// import FormHelperText from '@material-ui/core/FormHelperText';
import { useParams } from 'react-router-dom';
import { useIntl, FormattedMessage } from 'react-intl';
import {
    RadioGroup,
    Radio,
    FormControlLabel,
    FormHelperText,
} from '@material-ui/core';
import Validation from '../../common/Validation';
import CustomTypography from '../../components/Typography/CustomTypography';
import Button from '../../components/Button/CustomButton';
import styles from '../../assets/jss/pages/DialogEditCompanyOrganizerStyle';
import GridContainer from '../../components/Grid/GridContainer';
import GridItem from '../../components/Grid/GridItem';
import FormDialog from '../../components/Dialog/FormDialog';
import CleanableInput from '../../components/Input/CleanableInput';
import UploadButton from '../../components/Button/UploadButton';
import SelectorInput from '../../components/Input/SelectorInput';
import { locationOption } from '../../common/Constants';
// import { APIErrors } from '../../common/Constants';
import dateUtils from '../../utils/dateUtils';
import CustomTable from '../../components/Table/Table';
import Typography from '../../components/Typography/CustomTypography';
import API from '../../common/API';

const useStyles = makeStyles(styles);
const noRegis = '申し込んでいません。';
export default function DialogEditCompanyOrganizer(props) {
    const {
        isOpen,
        isClose,
        detailCompanyOrganizer,
        editSuccess,
        editErrors,
        fetchGetDetailCompanyOrganizer,
        fetchEditCompanyOrganizerRequested,
        fetchClearEditCompanyOrganizer,
        eventInfo,
        options,
        fetchJobs,
        jobs,
        zones,
        category,
        fetchCategory,
        customText,
        occupations,
        getOccupations,
        clearOccupations,
    } = props;
    const classes = useStyles();
    const intl = useIntl();
    const urlParams = useParams();
    const [validateResults, setValidateResults] = useState({});
    const [previewImage, setPreviewImage] = useState('');
    const [isChangeImage, setisChangeImage] = useState(false);
    const [companyInfo, setcompanyInfo] = useState({});
    const [seminarDetails, setSeminarDetails] = useState([]);
    const [listOptionCompanyFromApi, setListOptionCompanyFromApi] = useState({});
    const [listOptionEmployeeNumberFromApi, setOptionEmployeeNumberFromApi] = useState({});
    const [jobStates, setJobState] = useState({});
    const [categoryStates, setCategoryState] = useState({});
    const [occupationStates, setOccupationState] = useState({});
    const [liveStreamDetail, setLiveStreamDetail] = useState([]);

    useEffect(() => {
        const { shortName } = urlParams;
        fetchJobs(shortName);
        fetchCategory(shortName);
        getOccupations({ shortName });
        return () => {
            clearOccupations();
        };
    }, []);

    useEffect(() => {
        if (isOpen) {
            fetchGetDetailCompanyOrganizer();
        }
    }, [isOpen]);

    // Set list Option Company
    useEffect(() => {
        if (options && options.company_option) {
            let temp = {};
            options.company_option.forEach((key, i) => {
                temp = { ...temp, [i]: key[i] };
            });
            setListOptionCompanyFromApi({ ...listOptionCompanyFromApi, ...temp });
        }
    }, [options]);

    // Set list employee_number
    useEffect(() => {
        if (options && options.employee_number_option) {
            let temp = {};
            options.employee_number_option.forEach((key, i) => {
                temp = { ...temp, [i]: key[i] };
            });
            setOptionEmployeeNumberFromApi({ ...listOptionEmployeeNumberFromApi, ...temp });
        }
    }, [options]);

    useEffect(() => {
        if (!_.isEmpty(detailCompanyOrganizer)) {
            setcompanyInfo({
                ...companyInfo,
                fullName: detailCompanyOrganizer.fullName,
                fullNameEN: detailCompanyOrganizer.fullNameEN,
                shortName: detailCompanyOrganizer.shortName,
                // shortNameEN: detailCompanyOrganizer.shortNameEN,
                companyType: detailCompanyOrganizer.companyType,
                companyCategory:detailCompanyOrganizer.companyCategory,
                department: detailCompanyOrganizer.department,
                url: detailCompanyOrganizer.url,
                position: detailCompanyOrganizer.position,
                location: detailCompanyOrganizer.location,
                address: detailCompanyOrganizer.address,
                addressEN: detailCompanyOrganizer.addressEN,
                firstName: detailCompanyOrganizer.firstName,
                lastName: detailCompanyOrganizer.lastName,
                description: detailCompanyOrganizer.description,
                descriptionEN: detailCompanyOrganizer.descriptionEN,
                zipCode: detailCompanyOrganizer.zipCode,
                phoneNumber: detailCompanyOrganizer.phoneNumber,
                faxNumber: detailCompanyOrganizer.faxNumber,
                register_ads_max: detailCompanyOrganizer.register_ads_max,
                seminars: detailCompanyOrganizer.seminars,
                employee_number: detailCompanyOrganizer.employee_number,
                occupation_name: detailCompanyOrganizer.occupation_name,
                live_stream: detailCompanyOrganizer.live_stream,
                // eslint-disable-next-line no-nested-ternary
                has_payment: +detailCompanyOrganizer.has_payment === 1 ? '1' : +detailCompanyOrganizer.has_payment ? '2' : '0',
            });
            setPreviewImage(detailCompanyOrganizer.image && detailCompanyOrganizer.image.concat('?=', new Date().getTime().toString()));
        }
    }, [detailCompanyOrganizer]);

    const validate = () => {
        const {
            firstName, lastName, address, department, position, fullName,
            shortName, companyType, url, description,
            location, phoneNumber, faxNumber, zipCode, employee_number, occupation_name,
            addressEN, fullNameEN, shortNameEN, descriptionEN,
        } = companyInfo;
        const validateRules = {
            full_name: [
                () => Validation.isNotEmpty(fullName),
                () => Validation.validateMaxLength(fullName, 60),
            ],
            short_name: [
                () => Validation.isNotEmpty(shortName),
                () => Validation.validateMaxLength(shortName, 60),
            ],
            company_type: [
                () => Validation.isNotEmpty(companyType),
                () => Validation.validateMaxLength(companyType, 255),
            ],
            url: [
                () => Validation.validateMaxLength(url, 500),
                () => Validation.isValidUrl(url),
            ],
            description: [
                () => Validation.isNotEmpty(description),
                () => Validation.validateMaxLength(description, 1000),
            ],
            first_name: [
                () => Validation.isNotEmpty(firstName),
                () => Validation.validateMaxLength(firstName, 255),
            ],
            last_name: [
                () => Validation.isNotEmpty(lastName),
                () => Validation.validateMaxLength(lastName, 255),
            ],
            department: [() => Validation.validateMaxLength(department, 255)],
            position: [() => Validation.validateMaxLength(position, 255)],
            location: [() => Validation.validateMaxLength(location, 255)],
            zip_code: [() => Validation.isNotEmpty(zipCode),
                () => Validation.validateMaxLength(zipCode, 255)],
            address: [() => Validation.isNotEmpty(address),
                () => Validation.validateMaxLength(address, 1000)],
            phone_number: [() => Validation.isNotEmpty(phoneNumber),
                () => Validation.validatePhoneNumber(phoneNumber && phoneNumber.trim())],
            fax_number: [() => Validation.validateMaxLength(faxNumber, 255)],
            employee_number: [() => Validation.isNotEmpty(listOptionEmployeeNumberFromApi[employee_number]),
                () => Validation.validateMaxLength(employee_number, 255)],
            occupation_name: [() => Validation.isNotEmpty(occupation_name),
                () => Validation.validateMaxLength(occupation_name, 255)],
        };
        if (!_.isEmpty(eventInfo.languages)) {
            validateRules.addressEN = [
                () => Validation.isNotEmpty(addressEN),
                () => Validation.validateLatin(addressEN),
                () => Validation.validateMaxLength(addressEN, 1000),
            ];
            validateRules.full_name_en = [
                () => Validation.isNotEmpty(fullNameEN),
                () => Validation.validateLatin(fullNameEN),
                () => Validation.validateMaxLength(fullNameEN, 60),
            ];
            // validateRules.short_name_en = [
            //     () => Validation.isNotEmpty(shortNameEN),
            //     () => Validation.validateLatin(shortNameEN),
            //     () => Validation.validateMaxLength(shortNameEN, 60),
            // ];
            validateRules.descriptionEN = [
                () => Validation.isNotEmpty(descriptionEN),
                () => Validation.validateLatin(descriptionEN),
                () => Validation.validateMaxLength(descriptionEN, 1000),
            ];
        }
        const validateResult = Validation.validateAllRules(validateRules);

        if (Object.keys(validateResult).length > 0) {
            setValidateResults({ ...validateResult });
            window.scrollTo(0, 0);
            return false;
        }
        setValidateResults({});
        return true;
    };

    useEffect(() => {
        if (!_.isEmpty(jobs)) {
            setJobState(_.reduce(jobs, (result, value) => ({ ...result, [value]: value }), { '': '' }));
        }
    }, [jobs]);

    useEffect(() => {
        if (!_.isEmpty(category)) {
            setCategoryState(_.reduce(category, (result, value) => ({ ...result, [value]: value }), { '': '' }));
        }
    }, [category]);

    useEffect(() => {
        if (!_.isEmpty(occupations)) {
            setOccupationState(_.reduce(occupations, (result, value) => ({ ...result, [value]: value }), { '': '' }));
        }
    }, [occupations]);

    useEffect(() => {
        const { live_stream } = detailCompanyOrganizer;
        if (live_stream) {
            const arrData = [];
            live_stream.forEach((event) => {
                arrData.push([
                    event.title,
                    `${event.stime}~${event.etime}`,
                    (event.dates).map((date) => <p>{[date.slice(0, 4), '/', date.slice(5, 7), '/', date.slice(8, 10)].join('')}</p>),
                    event.cost ? `${intl.formatNumber(event.cost)} 円` : '無料',
                ]);
            });

            setLiveStreamDetail(arrData);
        } else {
            setLiveStreamDetail([]);
        }
    }, [detailCompanyOrganizer.live_stream]);

    const handleSetcompanyInfo = useCallback((field, valueChange) => {
        setcompanyInfo((prevcompanyInfo) => ({ ...prevcompanyInfo, [field]: valueChange }));
    }, []);

    const handleUploadImage = (file) => {
        handleSetcompanyInfo('image', file);
        setisChangeImage(true);
    };

    const handleIsClose = () => {
        setValidateResults({});
        setisChangeImage(false);
        isClose();
    };

    useEffect(() => {
        if (editSuccess) {
            fetchClearEditCompanyOrganizer();
            handleIsClose();
        } else if (!_.isEmpty(editErrors)) {
            if (editErrors.code === 'BAD_REQUEST') {
                setValidateResults({
                    ...validateResults,
                    ...editErrors,
                });
                fetchClearEditCompanyOrganizer();
                // handleIsClose();
            }
        }
    }, [editSuccess, editErrors, validateResults]);

    useEffect(() => {
        const { seminars } = detailCompanyOrganizer;
        if (seminars) {
            const arrData = [];
            seminars.forEach((element) => {
                arrData.push([
                    `${element.room} ( ${element.organization_price}円 )`,
                    dateUtils.formatJa(new Date(element.date)),
                    `${element.stime} ~ ${element.etime}`,
                ]);
            });

            setSeminarDetails(arrData);
        } else {
            setSeminarDetails([]);
        }
    }, [detailCompanyOrganizer.seminars]);

    const handleEditCompany = () => {
        if (validate()) {
            fetchEditCompanyOrganizerRequested({
                ...(companyInfo.image && isChangeImage && { company_image: companyInfo.image }),
                ...(!companyInfo.image && isChangeImage && { remove_image: 1 }),
                ...(companyInfo.addressEN && !_.isEmpty(eventInfo.languages) && { address_en: companyInfo.addressEN }),
                ...(companyInfo.fullNameEN && !_.isEmpty(eventInfo.languages) && { company_full_name_en: companyInfo.fullNameEN }),
                // ...(companyInfo.shortNameEN && !_.isEmpty(eventInfo.languages) && { company_short_name_en: companyInfo.shortNameEN }),
                ...(companyInfo.descriptionEN && !_.isEmpty(eventInfo.languages) && { company_description_en: companyInfo.descriptionEN }),
                company_full_name: companyInfo.fullName,
                company_short_name: companyInfo.shortName,
                company_type: companyInfo.companyType,
                companyCategory: companyInfo.companyCategory,
                company_url: companyInfo.url,
                company_description: companyInfo.description,
                first_name: companyInfo.firstName,
                last_name: companyInfo.lastName,
                department: companyInfo.department,
                position: companyInfo.position,
                location: companyInfo.location,
                address: companyInfo.address,
                zip_code: companyInfo.zipCode,
                phone_number: companyInfo.phoneNumber,
                fax_number: companyInfo.faxNumber,
                employee_number: companyInfo.employee_number,
                occupation_name: companyInfo.occupation_name,
            });
        }
    };
    const renderBoothType = (type) => {
        switch (type) {
            case 1:
                return _.get(eventInfo, 'setting_booth.small_zone.name');
            case 2:
                return _.get(eventInfo, 'setting_booth.standard_zone.name');
            case 3:
                return _.get(eventInfo, 'setting_booth.big_zone.name');
            case 4:
                return _.get(eventInfo, 'setting_booth.grand_zone.name');
            default:
                return <CustomTypography>{noRegis}</CustomTypography>;
        }
    };

    const actionsButton = () => (
        <>
            <Box style={{ margin: 'auto' }}>
                <Button
                    autoFocus
                    gradient
                    onClick={handleEditCompany}
                    size="md"
                    color="success"
                    style={{ width: '200px', fontSize: '20px', left: ' 20%' }}
                >
                    <FormattedMessage id="save" />
                </Button>
                <Button
                    autoFocus
                    gradient
                    onClick={handleIsClose}
                    size="md"
                    color="danger"
                    style={{ width: '150px', marginRight: '10px', left: ' 80%' }}
                >
                    <FormattedMessage id="cancel" />
                </Button>
            </Box>
        </>
    );
    const handleInputPostalCode = (valueInput) => {
        handleSetcompanyInfo('zipCode', valueInput);
        valueInput = valueInput.trim();
        const code = valueInput.substr(0, 3);
        if (code && code.length === 3 && valueInput.length === 7) {
            const pathPostal = process.env.REACT_APP_POSTAL_URL || '';
            fetch(`${pathPostal}/postal/${code}.json`)
                .then((res) => res.json())
                .then((data) => {
                    const d = data.find((it) => it[valueInput]);
                    handleSetcompanyInfo('address', d[valueInput][0]);
                }).catch(() => {
                    // TODO
                });
        } else {
            handleSetcompanyInfo('address', '');
        }
    };

    /* ★★★ tokuda update descriptionEN　AWS translation apply */
    const [ comDscrptTLData, setCompDscrptTLData ] = useState( { cJP:"", cEN:"" } );
    
    const handleCompDscrptJpEnTranslate= async (event)=>{
        const jN = event.target.value;
        setCompDscrptTLData((prevState)=>({
            ...prevState,
            cJP : jN,
        }));
        if( jN ===""){
            setCompDscrptTLData((prevState)=>({
                ...prevState,
                cEN : "",
            }));
            handleSetcompanyInfo('descriptionEN', "");
        }else{
            try {
                const response = await API.get({
                            endpoint: '/workTranslateJpEn/',
                            body    :  { japanese_name : jN}
                } );
                const EnNm     = response.english_name;
                setCompDscrptTLData((prevState)=>({
                    ...prevState,
                    cEN : EnNm,
                }));
                handleSetcompanyInfo('descriptionEN', EnNm);
            } catch (error){
                console.error('ERROR_jmbTranslate:',error);
            }
        }
    };
    const reproduce_CompDescriptionENbyYourHand=(val)=>{
        if(val===""){
            setCompDscrptTLData((prevState)=>({...prevState,cEN:"",}));
        }else{
            setCompDscrptTLData((prevState)=>({...prevState,cEN:val,}));
        }
    };



    return (
        <FormDialog
            isOpen={isOpen}
            handleClose={handleIsClose}
            title={customText?.content?.screen_name?.company_info_update ? customText.content.screen_name.company_info_update : '企業情報更新修正作業'}
            actions={actionsButton()}
        >
            <GridContainer>
                <GridItem>
                    <GridContainer className={classes.items}>
                        <GridItem xs={12} md={12}>
                            <CustomTypography variant="h6" bold color="info">
                                ※出展申込情報x
                            </CustomTypography>
                        </GridItem>
                    </GridContainer>

                    {(!_.isEmpty(zones) && !_.isEmpty(detailCompanyOrganizer)) && (
                        <GridContainer className={classes.items}>
                            <GridItem md={1} />
                            <GridItem xs={12} sm={4} md={4} className={classes.leftTitle}>
                                <CustomTypography bold>
                                    {intl.formatMessage({ id: 'zone' })}
                                </CustomTypography>
                            </GridItem>
                            <GridItem xs={12} sm={8} md={7} className={classes.rightInput}>
                                {zones?.length && zones.filter((item) => item.id === detailCompanyOrganizer.zone)[0]?.name}
                            </GridItem>
                        </GridContainer>
                    )}

                    <GridContainer className={classes.items}>
                        <GridItem md={1} />
                        <GridItem xs={12} sm={4} md={4} className={classes.leftTitle}>
                            <CustomTypography bold>
                                {customText?.content?.field_name?.zone || 'ブースタイプ'}
                            </CustomTypography>
                        </GridItem>
                        <GridItem xs={12} sm={8} md={7} className={classes.rightInput}>
                            <CustomTypography>
                                {renderBoothType(detailCompanyOrganizer.organizerBooth)}
                            </CustomTypography>
                        </GridItem>
                    </GridContainer>
                    <GridContainer className={classes.items}>
                        <GridItem md={1} />
                        <GridItem xs={12} sm={4} md={4} className={classes.leftTitle}>
                            <CustomTypography bold>
                                {customText?.content?.field_name?.seminar_hold || 'セミナー利用の申込み'}
                            </CustomTypography>
                        </GridItem>
                        <GridItem xs={12} sm={8} md={7} className={classes.rightInput}>
                            {seminarDetails.length > 0
                                ? (
                                    <CustomTable
                                        tableHead={[
                                            <>{customText?.content_seminar?.field_name?.conference_room || '会議室'}</>,
                                            <>{customText?.content_seminar?.field_name?.time_register || '月日'}</>,
                                            <>{customText?.content_seminar?.field_name?.time || '時間'}</>,
                                        ]}
                                        tableHeadWidth={['30%', '40%', '30%']}
                                        tableData={seminarDetails}
                                        className={classes.maxHeight}
                                        pointerLess
                                    />
                                )
                                : <CustomTypography>{noRegis}</CustomTypography>}
                        </GridItem>
                    </GridContainer>
                    <GridContainer className={classes.items}>
                        <GridItem md={1} />
                        <GridItem xs={12} sm={4} md={3}>
                            <CustomTypography bold>
                                {customText?.content?.field_name?.livestream_hold || 'ライブ配信'}
                            </CustomTypography>
                        </GridItem>
                        <GridItem xs={12} sm={8} md={8}>
                            {liveStreamDetail.length > 0
                                ? (
                                    <CustomTable
                                        tableHead={[
                                            <>{customText?.content_live_stream?.field_name?.title || 'タイトル'}</>,
                                            <>{customText?.content_live_stream?.field_name?.time_zone || '時間帯'}</>,
                                            <>{customText?.content_live_stream?.field_name?.dates || '日程'}</>,
                                            <>{customText?.content_live_stream?.field_name?.paid_and_free || '有料・無料'}</>,
                                        ]}
                                        tableHeadWidth={['30%', '25%', '25%', '20%']}
                                        tableData={liveStreamDetail}
                                        className={classes.maxHeight}
                                    />
                                )
                                : <CustomTypography>{noRegis}</CustomTypography>}
                        </GridItem>
                    </GridContainer>
                    <GridContainer className={classes.items}>
                        <GridItem md={1} />
                        <GridItem xs={12} sm={4} md={4} className={classes.leftTitle}>
                            <CustomTypography bold>
                                広告申込み
                            </CustomTypography>
                        </GridItem>
                        <GridItem xs={12} sm={8} md={7} className={classes.rightInput}>
                            <CustomTypography>
                                {detailCompanyOrganizer.register_ads_max > 0 ? `${detailCompanyOrganizer.register_ads_max} 件` : <CustomTypography>{noRegis}</CustomTypography>}
                            </CustomTypography>
                        </GridItem>
                    </GridContainer>
                    <GridContainer className={classes.items}>
                        <GridItem xs={12} md={12}>
                            <CustomTypography variant="h6" bold color="info">
                                {customText?.content?.field_name?.basic_info ? `※${customText?.content?.field_name?.basic_info}` : '※企業基本情報'}
                            </CustomTypography>
                        </GridItem>
                    </GridContainer>
                    <GridContainer className={classes.items}>
                        <GridItem md={1} />
                        <GridItem xs={12} sm={4} md={4} className={classes.leftTitle}>
                            <CustomTypography bold required>
                                {customText?.content?.field_name?.exhibitor_name || '出展企業名'}
                            </CustomTypography>
                            <CustomTypography>
                                {!_.isEmpty(eventInfo.languages) ? '（和文）' : '（和文・英文）'}
                            </CustomTypography>
                        </GridItem>
                        <GridItem xs={12} sm={8} md={7} className={classes.rightInput}>
                            <CleanableInput
                                required
                                defaultValue={companyInfo.fullName}
                                onChange={(value) => handleSetcompanyInfo('fullName', value)}
                                error={!!validateResults.full_name}
                                helperText={validateResults.full_name
                                    ? intl.formatMessage({ id: validateResults.full_name.message }, { maxLength: 60 }) : ''}
                            />
                        </GridItem>
                    </GridContainer>
                    {!_.isEmpty(eventInfo.languages) && (
                        <GridContainer className={classes.items}>
                            <GridItem md={1} />
                            <GridItem xs={12} sm={4} md={4} className={classes.leftTitle}>
                                <CustomTypography bold required>
                                    {customText?.content?.field_name?.exhibitor_name || '出展企業名'}
                                </CustomTypography>
                                <CustomTypography>
                                    （英文）
                                </CustomTypography>
                            </GridItem>
                            <GridItem xs={12} sm={8} md={7} className={classes.rightInput}>
                                <CleanableInput
                                    required
                                    defaultValue={companyInfo.fullNameEN}
                                    onChange={(value) => handleSetcompanyInfo('fullNameEN', value)}
                                    error={!!validateResults.full_name_en}
                                    helperText={validateResults.full_name_en
                                        ? intl.formatMessage({ id: validateResults.full_name_en.message }, { maxLength: 60 }) : ''}
                                />
                            </GridItem>
                        </GridContainer>
                    )}
                    <GridContainer className={classes.items}>
                        <GridItem md={1} />
                        <GridItem xs={12} sm={4} md={4} className={classes.leftTitle}>
                            <CustomTypography bold required>
                                {customText?.content?.field_name?.exhibitor_name || (!_.isEmpty(eventInfo.languages) ? '社名' : '出展企業名')}
                            </CustomTypography>
                            <CustomTypography>
                                {!_.isEmpty(eventInfo.languages) ? '（カナ）' : '（カナ・英字）'}
                            </CustomTypography>
                        </GridItem>
                        <GridItem xs={12} sm={8} md={7} className={classes.rightInput}>
                            <CleanableInput
                                defaultValue={companyInfo.shortName}
                                onChange={(value) => handleSetcompanyInfo('shortName', value)}
                                error={!!validateResults.short_name}
                                helperText={validateResults.short_name
                                    ? intl.formatMessage({ id: validateResults.short_name.message }, { maxLength: 60 }) : ''}
                            />
                        </GridItem>
                    </GridContainer>
                    {/* {!_.isEmpty(eventInfo.languages) && (
                        <GridContainer className={classes.items}>
                            <GridItem md={1} />
                            <GridItem xs={12} sm={4} md={4} className={classes.leftTitle}>
                                <CustomTypography bold required>
                                    {customText?.content?.field_name?.exhibitor_name || '社名'}
                                </CustomTypography>
                                <CustomTypography>
                                    （英字）
                                </CustomTypography>
                            </GridItem>
                            <GridItem xs={12} sm={8} md={7} className={classes.rightInput}>
                                <CleanableInput
                                    defaultValue={companyInfo.shortNameEN}
                                    onChange={(value) => handleSetcompanyInfo('shortNameEN', value)}
                                    error={!!validateResults.short_name_en}
                                    helperText={validateResults.short_name_en
                                        ? intl.formatMessage({ id: validateResults.short_name_en.message }, { maxLength: 60 }) : ''}
                                />
                            </GridItem>
                        </GridContainer>
                    )} */}
                    <GridContainer className={classes.items}>
                        <GridItem md={1} />
                        <GridItem xs={12} sm={4} md={4} className={classes.leftTitle}>
                            <CustomTypography bold>
                                {'分類'}
                            </CustomTypography>
                        </GridItem>
                        <GridItem xs={12} sm={5} md={5} className={classes.rightInput}>
                            <SelectorInput
                                optionList={categoryStates}
                                valueSelected={companyInfo.companyCategory}
                                onChange={(value) => handleSetcompanyInfo('companyCategory', value)}
                                
                                helperText={validateResults.companyCategory
                                    ? intl.formatMessage({ id: validateResults.companyCategory.message }, { maxLength: 255 }) : ''}
                            />
                        </GridItem>
                    </GridContainer>

                    <GridContainer className={classes.items}>
                        <GridItem md={1} />
                        <GridItem xs={12} sm={4} md={4} className={classes.leftTitle}>
                            <CustomTypography bold required>
                                {customText?.content?.field_name?.industry_type || '業種'}
                            </CustomTypography>
                        </GridItem>
                        <GridItem xs={12} sm={5} md={5} className={classes.rightInput}>
                            <SelectorInput
                                optionList={jobStates}
                                valueSelected={companyInfo.companyType}
                                onChange={(value) => handleSetcompanyInfo('companyType', value)}
                                error={!!validateResults.company_type}
                                helperText={validateResults.company_type
                                    ? intl.formatMessage({ id: validateResults.company_type.message }, { maxLength: 255 }) : ''}
                            />
                        </GridItem>
                    </GridContainer>
                    <GridContainer className={classes.items}>
                        <GridItem md={1} />
                        <GridItem xs={12} sm={4} md={4} className={classes.leftTitle}>
                            <CustomTypography bold required>
                                {customText?.content?.field_name?.job_type || '職種'}
                            </CustomTypography>
                        </GridItem>
                        <GridItem xs={12} sm={5} md={5} className={classes.rightInput}>
                            <SelectorInput
                                optionList={occupationStates}
                                valueSelected={companyInfo.occupation_name}
                                onChange={(value) => handleSetcompanyInfo('occupation_name', value)}
                                error={!!validateResults.occupation_name}
                                helperText={validateResults.occupation_name
                                    ? intl.formatMessage({ id: validateResults.occupation_name.message }, { maxLength: 255 }) : ''}
                            />
                        </GridItem>
                    </GridContainer>
                    <GridContainer className={classes.items}>
                        <GridItem md={1} />
                        <GridItem xs={12} sm={4} md={4} className={classes.leftTitle}>
                            <CustomTypography bold required>
                                {customText?.content?.field_name?.number_employees || '従業員数'}
                            </CustomTypography>
                        </GridItem>
                        <GridItem xs={12} sm={5} md={5} className={classes.rightInput}>
                            <SelectorInput
                                optionList={listOptionEmployeeNumberFromApi}
                                valueSelected={companyInfo.employee_number}
                                onChange={(value) => handleSetcompanyInfo('employee_number', value)}
                                error={!!validateResults.employee_number}
                                helperText={validateResults.employee_number
                                    ? intl.formatMessage({ id: validateResults.employee_number.message }, { maxLength: 255 }) : ''}
                            />

                        </GridItem>
                    </GridContainer>

                    <GridContainer className={classes.items}>
                        <GridItem>
                            <CustomTypography variant="h6" bold color="info">
                                {customText?.content?.field_name?.contact_person ? `※${customText?.content?.field_name?.contact_person}` : '※連絡担当者'}
                            </CustomTypography>
                        </GridItem>
                    </GridContainer>
                    <GridContainer className={classes.items}>
                        <GridItem md={1} />
                        <GridItem xs={12} sm={4} md={4} className={classes.leftTitle}>
                            <CustomTypography bold>
                                {customText?.content?.field_name?.department || '部署'}
                            </CustomTypography>
                        </GridItem>
                        <GridItem xs={12} sm={8} md={7} className={classes.rightInput}>
                            <CleanableInput
                                defaultValue={companyInfo.department}
                                onChange={(value) => handleSetcompanyInfo('department', value)}
                                error={!!validateResults.department}
                                helperText={validateResults.department
                                    ? intl.formatMessage({ id: validateResults.department.message }, { maxLength: 255 }) : ''}
                            />
                        </GridItem>
                    </GridContainer>
                    <GridContainer className={classes.items}>
                        <GridItem md={1} />
                        <GridItem xs={12} sm={4} md={4} className={classes.leftTitle}>
                            <CustomTypography bold>
                                {customText?.content?.field_name?.position || '役職'}
                            </CustomTypography>
                        </GridItem>
                        <GridItem xs={12} sm={8} md={7} className={classes.rightInput}>
                            <CleanableInput

                                defaultValue={companyInfo.position}
                                onChange={(value) => handleSetcompanyInfo('position', value)}
                                error={!!validateResults.position}
                                helperText={validateResults.position
                                    ? intl.formatMessage({ id: validateResults.position.message }, { maxLength: 255 }) : ''}
                            />
                        </GridItem>
                    </GridContainer>
                    <GridContainer className={classes.items}>
                        <GridItem md={1} />
                        <GridItem xs={12} sm={4} md={4} className={classes.leftTitle}>
                            <CustomTypography bold required>
                                {customText?.content?.field_name?.name || '氏名'}
                            </CustomTypography>
                        </GridItem>
                        <GridItem xs={12} sm={8} md={7}>
                            <GridContainer className={classes.rightInput}>
                                <GridItem xs={12} md={6} className={classes.lineInput}>
                                    <CustomTypography bold>姓</CustomTypography>
                                    <CleanableInput
                                        defaultValue={companyInfo.firstName}
                                        onChange={(value) => handleSetcompanyInfo('firstName', value)}
                                        error={!!validateResults.first_name}
                                        helperText={validateResults.first_name
                                            ? intl.formatMessage({ id: validateResults.first_name.message }, { maxLength: 255 }) : ''}
                                    />
                                </GridItem>
                                <GridItem xs={12} md={6} className={classes.lineInput} style={{ paddingRight: '0px' }}>
                                    <CustomTypography bold>名</CustomTypography>
                                    <CleanableInput
                                        defaultValue={companyInfo.lastName}
                                        onChange={(value) => handleSetcompanyInfo('lastName', value)}
                                        error={!!validateResults.last_name}
                                        helperText={validateResults.last_name
                                            ? intl.formatMessage({ id: validateResults.last_name.message }, { maxLength: 255 }) : ''}
                                    />
                                </GridItem>
                            </GridContainer>
                        </GridItem>
                    </GridContainer>
                    <GridContainer className={classes.items}>
                        <GridItem md={1} />
                        <GridItem xs={12} sm={4} md={4} className={classes.leftTitle}>
                            <CustomTypography bold>
                                {customText?.content?.field_name?.country_region || '国・地域'}
                            </CustomTypography>
                        </GridItem>
                        <GridItem xs={12} sm={5} md={5} className={classes.rightInput}>
                            <SelectorInput
                                valueSelected={companyInfo.location}
                                optionList={locationOption.ja}
                                onChange={(valueInput) => handleSetcompanyInfo('location', valueInput)}
                                error={!!validateResults.location}
                                helperText={validateResults.location
                                    ? intl.formatMessage({ id: validateResults.location.message }, { maxLength: 255 }) : ''}
                            />
                        </GridItem>
                    </GridContainer>
                    <GridContainer className={classes.items}>
                        <GridItem md={1} />
                        <GridItem xs={12} sm={4} md={4} className={classes.leftTitle}>
                            <CustomTypography bold required>
                                {customText?.content?.field_name?.zip_code || '郵便番号'}
                            </CustomTypography>
                        </GridItem>
                        <GridItem xs={12} sm={8} md={7} className={classes.rightInput}>
                            <GridContainer>
                                <GridItem xs={12} sm={6} md={6} className={classes.lineInput}>
                                    <CleanableInput
                                        isFullWidth
                                        defaultValue={companyInfo.zipCode}
                                        onChange={(valueInput) => handleInputPostalCode(valueInput)}
                                        error={!!validateResults.zip_code}
                                        helperText={validateResults.zip_code
                                            ? intl.formatMessage(
                                                { id: validateResults.zip_code.message },
                                                { maxLength: 255 },
                                            ) : ''}
                                    />
                                </GridItem>
                            </GridContainer>
                        </GridItem>
                    </GridContainer>
                    <GridContainer className={classes.items}>
                        <GridItem md={1} />
                        <GridItem xs={12} sm={4} md={4} className={classes.leftTitle}>
                            <CustomTypography bold required>
                                {!_.isEmpty(eventInfo.languages)
                                    ? `${customText?.content?.field_name?.address || '住所'}（和文）`
                                    : (customText?.content?.field_name?.address || '住所')}
                            </CustomTypography>
                        </GridItem>
                        <GridItem xs={12} sm={8} md={7} className={classes.rightInput}>
                            <CleanableInput
                                defaultValue={companyInfo.address}
                                onChange={(value) => handleSetcompanyInfo('address', value)}
                                error={!!validateResults.address}
                                helperText={validateResults.address
                                    ? intl.formatMessage({ id: validateResults.address.message }, { maxLength: 1000 }) : ''}
                            />
                        </GridItem>
                    </GridContainer>
                    {!_.isEmpty(eventInfo.languages) && (
                        <GridContainer className={classes.items}>
                            <GridItem md={1} />
                            <GridItem xs={12} sm={4} md={4} className={classes.leftTitle}>
                                <CustomTypography bold required>
                                    {`${customText?.content?.field_name?.address || '住所'}（英文）`}
                                </CustomTypography>
                            </GridItem>
                            <GridItem xs={12} sm={8} md={7} className={classes.rightInput}>
                                <CleanableInput
                                    defaultValue={companyInfo.addressEN}
                                    onChange={(value) => handleSetcompanyInfo('addressEN', value)}
                                    error={!!validateResults.addressEN}
                                    helperText={validateResults.addressEN
                                        ? intl.formatMessage({ id: validateResults.addressEN.message }, { maxLength: 1000 }) : ''}
                                />
                            </GridItem>
                        </GridContainer>
                    )}
                    <GridContainer className={classes.items}>
                        <GridItem md={1} />
                        <GridItem xs={12} sm={4} md={4} className={classes.leftTitle}>
                            <CustomTypography bold required>
                                {customText?.content?.field_name?.phone_number || '電話番号'}
                            </CustomTypography>
                        </GridItem>
                        <GridItem xs={12} sm={8} md={7} className={classes.rightInput}>
                            <GridContainer>
                                <GridItem xs={12} sm={6} md={6} className={classes.lineInput}>
                                    <CleanableInput
                                        isFullWidth
                                        defaultValue={companyInfo.phoneNumber}
                                        onChange={(valueInput) => handleSetcompanyInfo('phoneNumber', valueInput)}
                                        error={!!validateResults.phone_number}
                                        helperText={validateResults.phone_number
                                            ? intl.formatMessage({ id: validateResults.phone_number.message }, { maxLength: 255 }) : ''}
                                    />
                                </GridItem>
                            </GridContainer>
                        </GridItem>
                    </GridContainer>
                    <GridContainer className={classes.items}>
                        <GridItem md={1} />
                        <GridItem xs={12} sm={4} md={4} className={classes.leftTitle}>
                            <CustomTypography bold>
                                {customText?.content?.field_name?.fax_number || 'FAX 番号'}
                            </CustomTypography>
                        </GridItem>
                        <GridItem xs={12} sm={8} md={7} className={classes.rightInput}>
                            <GridContainer>
                                <GridItem xs={12} sm={6} md={6} className={classes.lineInput}>
                                    <CleanableInput
                                        defaultValue={companyInfo.faxNumber}
                                        onChange={(valueInput) => handleSetcompanyInfo('faxNumber', valueInput)}
                                        error={!!validateResults.faxNumber}
                                        helperText={validateResults.faxNumber
                                            ? intl.formatMessage({ id: validateResults.faxNumber.message }, { maxLength: 255 }) : ''}
                                    />
                                </GridItem>
                            </GridContainer>
                        </GridItem>
                    </GridContainer>
                    <GridContainer className={classes.items}>
                        <GridItem md={1} />
                        <GridItem xs={12} sm={4} md={4} className={classes.leftTitle}>
                            <CustomTypography bold>
                                {customText?.content?.field_name?.url || 'ＵＲＬ'}
                            </CustomTypography>
                        </GridItem>
                        <GridItem xs={12} sm={8} md={7} className={classes.rightInput}>
                            <CleanableInput
                                defaultValue={companyInfo.url}
                                onChange={(value) => handleSetcompanyInfo('url', value)}
                                error={!!validateResults.url}
                                helperText={validateResults.url
                                    ? intl.formatMessage({ id: validateResults.url.message }, { maxLength: 500 }) : ''}
                            />
                        </GridItem>
                    </GridContainer>
                    <GridContainer className={classes.items}>
                        <GridItem md={1} />
                        <GridItem xs={12} sm={4} md={4} className={classes.leftTitle}>
                            <CustomTypography bold>
                                {customText?.content?.field_name?.guide_image || intl.formatMessage({ id: 'register.guideImage' })}
                            </CustomTypography>
                        </GridItem>
                        <GridItem xs={12} sm={8} md={7} className={classes.rightInput}>
                            <UploadButton
                                type="image"
                                text={customText?.content?.button_name?.upload_image ? customText.content.button_name.upload_image : 'Upload an Image'}
                                onChange={(value) => handleUploadImage(value)}
                                imagePreview={previewImage}
                                isHasClear
                            />
                        </GridItem>
                    </GridContainer>
                    <GridContainer className={classes.items}>
                        <GridItem md={1} />
                        <GridItem xs={12} sm={4} md={4} className={classes.leftTitle}>
                            <CustomTypography bold required>
                                {!_.isEmpty(eventInfo.languages)
                                    ? `${customText?.content?.field_name?.info_guide || intl.formatMessage({ id: 'register.guideInfo' })}（和文）`
                                    : (customText?.content?.field_name?.info_guide || intl.formatMessage({ id: 'register.guideInfo' }))}
                            </CustomTypography>
                        </GridItem>
                        <GridItem xs={12} sm={8} md={7} className={classes.rightInput}>
                            <>
                            <CleanableInput
                                      isMultiline
                                        rows={3}
                                        onChange={(value) => handleSetcompanyInfo('description', value)}
                                        onBlur={(event) => {
                                            handleCompDscrptJpEnTranslate(event);
                                            console.log("jp_companyDescription" + event.target.value);
                                            }      
                                        }
                                        defaultValue={companyInfo.description}
                                        error={!!validateResults.description}
                                        helperText={validateResults.description
                                            ? intl.formatMessage(
                                                { id: validateResults.description.message },
                                                { maxLength: 1000 },
                                            ) : ''}
                                    />
                                    <CustomTypography>
                                        {intl.formatMessage({ id: 'registerViewer.jpEnTranslateHelp' })}
                                    </CustomTypography>
                            </>                            
                        </GridItem>
                    </GridContainer>
                    {!_.isEmpty(eventInfo.languages) && (
                        <GridContainer className={classes.items}>
                            <GridItem md={1} />
                            <GridItem xs={12} sm={4} md={4} className={classes.leftTitle}>
                                <CustomTypography bold required>
                                    {`${customText?.content?.field_name?.info_guide || intl.formatMessage({ id: 'register.guideInfo' })}（英文）`}
                                </CustomTypography>
                            </GridItem>
                            <GridItem xs={12} sm={8} md={7} className={classes.rightInput}>

                                <CleanableInput
                                            isMultiline
                                            rows={3}
//                                            defaultValue={companyInfo.descriptionEN}
                                            onChange={(value) => {  reproduce_CompDescriptionENbyYourHand(value);
                                                handleSetcompanyInfo('descriptionEN', value);
                                                console.log("descriptionEN" + value);
                                            }  }
                                            defaultValue={companyInfo.descriptionEN}
                                            error={!!validateResults.descriptionEN}
                                            helperText={validateResults.descriptionEN
                                                ? intl.formatMessage(
                                                    { id: validateResults.descriptionEN.message },
                                                    { maxLength: 1000 },
                                                ) : ''}
                                />

                            </GridItem>
                        </GridContainer>
                    )}
                    <GridContainer className={classes.items} style={{ alignItems: 'center' }}>
                        <GridItem md={1} />
                        <GridItem xs={12} sm={4} md={4} className={classes.leftTitle}>
                            <CustomTypography required bold>
                                {customText?.field_name?.exhibitor_payment || '支払い方法'}
                            </CustomTypography>
                        </GridItem>
                        <GridItem xs={12} sm={8} md={7} className={classes.rightInput}>
                            <GridContainer>
                                <GridItem xs={12} md={12} className={classes.paymentField}>
                                    <RadioGroup
                                        name="has_payment"
                                        value={companyInfo.has_payment}
                                        row
                                    >
                                        <FormControlLabel
                                            value="1"
                                            control={<Radio color="primary" />}
                                            label={<CustomTypography>クレジット</CustomTypography>}
                                        />
                                        <FormControlLabel
                                            value="2"
                                            control={<Radio color="primary" />}
                                            label={<CustomTypography>銀行口座</CustomTypography>}
                                            className={classes.label}
                                        />
                                    </RadioGroup>
                                </GridItem>
                            </GridContainer>
                        </GridItem>
                    </GridContainer>
                </GridItem>
            </GridContainer>
        </FormDialog>
    );
}

DialogEditCompanyOrganizer.defaultProps = {
    fetchGetDetailCompanyOrganizer: () => { },
    // fetchClearGetDetailCompanyOrganizer: () => { },
    fetchEditCompanyOrganizerRequested: () => { },
    fetchClearEditCompanyOrganizer: () => { },
    isOpen: true,
    isClose: false,
    detailCompanyOrganizer: {},
    editErrors: {},
    eventInfo: {},
    options: {},
    editSuccess: false,
    fetchJobs: () => { },
    jobs: {},
    fetchCategory: () => { },
    category: {},
    customText: {},
    getOccupations: () => {},
    occupations: {},
    clearOccupations: {},
};

DialogEditCompanyOrganizer.propTypes = {
    fetchGetDetailCompanyOrganizer: PropTypes.func,
    fetchEditCompanyOrganizerRequested: PropTypes.func,
    fetchClearEditCompanyOrganizer: PropTypes.func,
    isOpen: PropTypes.bool,
    isClose: PropTypes.bool,
    editSuccess: PropTypes.bool,
    detailCompanyOrganizer: PropTypes.oneOfType([() => null, PropTypes.object]),
    editErrors: PropTypes.oneOfType([() => null, PropTypes.object]),
    eventInfo: PropTypes.oneOfType([() => null, PropTypes.object]),
    options: PropTypes.oneOfType([() => null, PropTypes.object]),
    fetchJobs: PropTypes.func,
    jobs: PropTypes.oneOfType([() => null, PropTypes.array]),
    fetchCategory: PropTypes.func,
    category: PropTypes.oneOfType([() => null, PropTypes.array]),
    zones: PropTypes.oneOfType([null, PropTypes.array]).isRequired,
    customText: PropTypes.oneOfType([() => null, PropTypes.object]),
    getOccupations: PropTypes.func,
    occupations: PropTypes.oneOfType([() => null, PropTypes.object]),
    clearOccupations: PropTypes.func,
};
